var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.206 2.8981C4.27357 3.01189 3.49313 3.38458 2.83254 4.03322C2.23917 4.61358 1.88257 5.22808 1.67796 6.02751C1.31551 7.41298 1.57858 8.77854 2.44963 10.0616C3.00792 10.8838 3.72989 11.6377 5.054 12.787C5.89582 13.5182 8.46511 15.6519 8.5908 15.723C8.70772 15.7913 8.75157 15.7998 9.00002 15.7998C9.24847 15.7998 9.29232 15.7913 9.40924 15.723C9.53492 15.6519 12.1101 13.5153 12.946 12.787C14.276 11.632 14.9921 10.8809 15.5504 10.0616C16.4215 8.77854 16.6845 7.41298 16.3221 6.02751C16.1175 5.22808 15.7609 4.61358 15.1675 4.03322C14.5771 3.4557 13.9457 3.12284 13.1185 2.95215C12.7034 2.8668 11.9376 2.85827 11.5752 2.93793C10.5638 3.15129 9.78922 3.64347 9.08186 4.5197L9.00002 4.61927L8.9211 4.5197C8.22251 3.66053 7.45961 3.16836 6.48626 2.95215C6.19688 2.88672 5.53045 2.85827 5.206 2.8981Z",
    fill: "#EE8FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikedIcon);
export default __webpack_public_path__ + "static/media/liked-icon.aea27e55056bff5c1e5734e8b8e3bc0e.svg";
export { ForwardRef as ReactComponent };